import { useMemo } from "react"

import { Separator, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui"

import PositionImageProperty from "../PositionImage"
import { PredefinedArbitraryUnit } from "../PredefinedArbitraryUnit"

import { TRANSFORM_CONFIG } from "."

export default function CustomTransform({ displayCustomProps = [], transform = {}, onChange }) {
  return <>
    {displayCustomProps.map((name, index) => {
      const { config, label } = TRANSFORM_CONFIG.find(item => item.value === name) || {}
      const Component = config?.component
      const props = config?.props || {}

      return <>
        {label || name}
        <Component {...props} show={true} transform={transform} onChange={onChange} key={name} />
        {index !== displayCustomProps.length - 1 && <Separator className='m-0 my-2' />}
      </>
    })}
  </>
}

const TransformStyle = ({ show, onChange, transform }) => {
  if (!show) {
    return null
  }

  return <>
    <ToggleOptionGroup className='w-full' size='lg' value={transform.transformStyle || ''} type='single' onValueChange={value => onChange({ ...transform, transformStyle: value || undefined })}>
      <ToggleOptionGroupItem value='transform-3d'>
        3D
      </ToggleOptionGroupItem>
      <ToggleOptionGroupItem value='transform-flat'>
        Flat
      </ToggleOptionGroupItem>
    </ToggleOptionGroup>
  </>
}

const PositionOrigin = ({ name, show, onChange, transform }) => {
  if (!show) {
    return null
  }

  const handleOnChange = value => {
    onChange({ ...transform, [name]: value })
  }

  return <>
    <PositionImageProperty
      onChange={handleOnChange}
      value={transform[name]}
    />
  </>
}

const Perspective = ({ onChange, transform }) => {
  const value = useMemo(() => transform?.perspective || '', [transform])

  const handleChange = perspective => {
    onChange({ ...transform, perspective })
  }

  return <PredefinedArbitraryUnit
    value={value}
    onChange={handleChange}
    predefined
    predefinedOptions={PERSPECTIVE_OPTIONS}
    defaultUnit='px'
  />
}

const Backface = ({ show, onChange, transform }) => {
  if (!show) {
    return null
  }

  return <>
    <ToggleOptionGroup className='w-full' size='lg' value={transform.backface || ''} type='single' onValueChange={value => onChange({ ...transform, backface: value || undefined })}>
      <ToggleOptionGroupItem value='backface-hidden'>
        Hidden
      </ToggleOptionGroupItem>
      <ToggleOptionGroupItem value='backface-visible'>
        Visible
      </ToggleOptionGroupItem>
    </ToggleOptionGroup>
  </>
}

const PERSPECTIVE_OPTIONS = [
  { label: 'Dramatic', value: 'dramatic' },
  { label: 'Near', value: 'near' },
  { label: 'Normal', value: 'normal' },
  { label: 'Midrange', value: 'midrange' },
  { label: 'Distant', value: 'distant' },
  { label: 'None', value: 'none' },
]

export {
  TransformStyle,
  PositionOrigin,
  Perspective,
  Backface,
}
